import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from "@angular/core";
import { SharedModule } from "@bb-vendure/admin-ui/core";

@Component({
  selector: "custom-chip",
  templateUrl: "./chip.component.html",
  styleUrls: ["./chip.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [SharedModule],
})
export class ChipComponent {
  @Input() icon: string;
  @Input() backgroundColor: string;
  @Input() color: string;
  @Output() iconClick = new EventEmitter<MouseEvent>();
}
